import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { UPLOADING_IMAGE_URL } from '../../../../../define/consts/assets';
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import Image from '../../../../Ui/Common/Image';
const AboutContentsPortfoliosItem = (props) => {
    const { portfolio, showPdfModal } = props;
    const setImage = portfolio.uploadFileThumbnail || UPLOADING_IMAGE_URL;
    const isLoaded = !!portfolio.uploadFileThumbnail;
    const onClick = useCallback(() => showPdfModal(portfolio.images), [showPdfModal, portfolio.images]);
    return (_jsxs("li", Object.assign({ className: `slider-list-item ${isLoaded ? 'is-clickable' : ''}`, onClick: isLoaded ? onClick : undefined, role: 'presentation' }, { children: [_jsx("div", Object.assign({ className: 'thumbnail' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isObjectFit: true, src: setImage }) })), _jsx("p", { children: portfolio.title })] })));
};
AboutContentsPortfoliosItem.propTypes = {
    portfolio: propShape().isRequired,
    showPdfModal: propFunc().isRequired,
};
export default AboutContentsPortfoliosItem;
